import React from "react";
//#region types
//#endregion
//#region components
import { PageLayouts, RouteBreadCrumb, useNavigationHistory } from "components/common";
import CreateCustomer from "./createCustomer";
import { useInvoicePermissions } from "components/invoice";
//#endregion

const CreateCustomerView: React.FC = (props) => {
  const { navigateToPreviousLocation } = useNavigationHistory();
  const { canCreateInvoices } = useInvoicePermissions();

  const onFormSubmitSuccess = (customerId?: number, customerName?: string) => {
    navigateToPreviousLocation({
      customerId: customerId,
      customerName: customerName,
    });
  };

  return (
    <PageLayouts.EntityFullScreen
      id={0}
      entityKey={`customer`}
      navigation={<RouteBreadCrumb />}
      hasPermissions={canCreateInvoices}
      hideSpeedDial
    >
      <CreateCustomer onFormSubmitSuccess={onFormSubmitSuccess}></CreateCustomer>
    </PageLayouts.EntityFullScreen>
  );
};

export default CreateCustomerView;
